import '@quromedical/fhir-common';
import { compose, resolveConstant } from '../composer';
import { allSchedules, medicationRouteCodes, normalSchedules } from './internal';
export const schedule = {
  allSchedules,
  normalSchedules
};
const resolveEmptyQuery = resolveConstant({
  routeCodes: [],
  schedules: []
});

const assertCanCreateUsage = _ref => {
  let {
    canCreateUsage
  } = _ref;

  if (canCreateUsage) {
    return undefined;
  }

  return {
    type: 'error',
    messages: ['Does not have permission to create medication usages']
  };
};

const assertCanCreatePrescription = _ref2 => {
  let {
    canCreatePrescription
  } = _ref2;

  if (canCreatePrescription) {
    return undefined;
  }

  return {
    type: 'error',
    messages: ['Does not have permission to create prescription']
  };
};

const medicationQueryAssertions = {
  'create-usage': [assertCanCreateUsage],
  'create-pharmacy-prescription': [assertCanCreatePrescription],
  'create-patient-prescription': [assertCanCreatePrescription]
};
const medicationQueryResolvers = {
  'create-pharmacy-prescription': resolveConstant({
    schedules: allSchedules,
    routeCodes: medicationRouteCodes
  }),
  'create-patient-prescription': resolveConstant({
    schedules: normalSchedules,
    routeCodes: medicationRouteCodes
  }),
  'create-usage': resolveConstant({
    schedules: allSchedules,
    routeCodes: medicationRouteCodes
  })
};

const assertKnownUse = _ref3 => {
  let {
    use
  } = _ref3;

  if (use !== 'unknown') {
    return undefined;
  }

  return {
    type: 'error',
    messages: ['Medication use must be specified']
  };
};
/**
 * Get query for medication based on the intended use
 */


export const resolveMedicationQuery = compose({
  getRuleName: _ref4 => {
    let {
      use = 'unknown'
    } = _ref4;
    return use;
  },
  assertions: medicationQueryAssertions,
  defaultAssertions: [assertKnownUse],
  resolvers: medicationQueryResolvers,
  defaultResolver: resolveEmptyQuery
});
//# sourceMappingURL=index.js.map